import { Component, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import {
  FavoriteSupplier,
  UnfavoriteSupplier,
} from 'src/app/order-admin/state/supplier/supplier.actions';

@Component({
  selector: 'app-order-admin-template',
  templateUrl: './order-admin-template.component.html',
  styleUrls: ['./order-admin-template.component.scss'],
  standalone: false,
})
export class OrderAdminTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;
  @Input() buttonFunctions: { [key: string]: () => void };

  constructor(private store: Store) {}

  favorite(): void {
    this.store.dispatch(new FavoriteSupplier(this.element.id));
  }

  unfavorite(): void {
    this.store.dispatch(new UnfavoriteSupplier(this.element.id));
  }
}
